import { createSlice } from '@reduxjs/toolkit';
import { UserState } from '../types/store.types';

export interface UserBranch {
  label: string;
  branchId: string;
  dispatchTime: string;
}

export interface UserBranchInput {
  _id: string;
  name: string;
  dispatch_start_time: string;
}

const initialState: UserState = {
  userInfo: null,
  domain: '',
  token: null,
  userStoreLoading: false,
  currentBranch: null,
  upSellDownSellPrice: undefined,
  branchListNew: [],
  crewRatesData: [],
  crewRatesLoading: false,
  zipCodeValue: '',
  version: '',
  featureAccess: null,
  permissions: [],
  userDetails: undefined,
};

const transformBranches = (branches: UserBranchInput[]): UserBranch[] => {
  return branches?.map((branch) => ({
    label: branch?.name,
    branchId: branch?._id,
    dispatchTime: branch?.dispatch_start_time,
  }));
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    signIn: (state, action) => {
      state.userInfo = action.payload;
    },
    loggedOut: () => initialState,
    updateDomain: (state, action) => {
      state.domain = action.payload;
    },
    updateToken: (state, action) => {
      state.token = action.payload;
    },
    updateLoading: (state, action) => {
      state.userStoreLoading = action.payload;
    },
    updateUserInfo: (state, { payload }) => {
      state.userInfo = payload;
    },
    updateCrewRates: (state, { payload }) => {
      state.crewRatesData = payload;
    },
    updateCrewRatesLoading: (state, { payload }) => {
      state.crewRatesLoading = payload;
    },
    updateZipCode: (state, { payload }) => {
      state.zipCodeValue = payload;
    },
    updateCurrentBranch: (state, action) => {
      state.currentBranch = action.payload;
    },
    updateUpSellDownSellPrice: (state, action) => {
      state.upSellDownSellPrice = action.payload;
    },
    handleBranchUpdateNew: (state, action) => {
      const branchListData = transformBranches(action?.payload);
      state.branchListNew = branchListData.sort((a, b) => a.label.localeCompare(b.label));
    },
    updateVersion: (state, action) => {
      state.version = action.payload;
    },
    updateFeatureAccess: (state, action) => {
      state.featureAccess = action.payload;
    },
  },
});

export const userActions = userSlice.actions;
export const userReducer = userSlice.reducer;
